export const TypeTicket = {
    Stretch: 'stretch', // también si ticket.type no tiene valor
    CollaboratorStretch: 'collaboratorStretch',
    Packet: 'packet',
    CollaboratorPacket: 'collaboratorPacket',
}

export type TypeTicket = string